export const STARS_GAME_ID = 2;
export const FIELDS_GAME_ID = 3;
export const LOOPY_RIVER_GAME_ID = 4;
export const MOSAIC_GAME_ID = 5;

// Boards publicly accessible without a subscription (e.g. event landing pages).
// TODO: replace with a per-board access-rule system.
export const PUBLIC_BOARD_DATES = new Set([
  '2025-04-28',
  '2025-05-12',
  '2025-06-02',
  '2025-03-19',
  '2025-03-29',
  '2025-05-25',
  '2026-02-15',
]);

export const LocalStorageKeys = {
  FIELDS_HOW_TO_PLAY_OPENED: 'fieldsHowToPlayOpened',
  FIELDS_MONDAY_PUZZLE_SEEN: 'fieldsMondaySeen',
  DAILY_REMINDER_SUBSCRIBER_EMAIL: 'stars_subscriber_email',
  PROMOTION_LAST_SHOWN_TIME: 'promotion_last_shown_time',
  INTRO_MODE_CACHE: 'introMode',
  LOCAL_PLAYS: 'localPlays',
  ACCOUNT_CTA_COMPLETED_GAMES: 'account_cta_completed_games',
  ACCOUNT_CTA_SHOWN_COUNT: 'account_cta_shown_count',
  // Epoch ms of the last request for persistent storage; see requestPersistence.
  STORAGE_PERSIST_ASKED_AT: 'storage_persist_asked_at',
  // JSON HeardAboutAnswer; see lib/heard-about.
  HEARD_ABOUT: 'heard_about',
  // The account whose profile HEARD_ABOUT has been saved to; see lib/heard-about.
  HEARD_ABOUT_SAVED_FOR: 'heard_about_saved_for',
};
